export enum QuestionRating {
  'all-ages' = 1,
  '18+',
  'xxx-rated',
}
